import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { DialogConfirm } from 'components'
import { cloneDeep } from 'lodash'
import { Alert, TextField } from '@mui/material'
import { createProcessKeyword, updateProcessKeyword } from "../../../../services/apiKYP"
import { OPERATION_MESSAGES } from "../../../../utils/constants/operations"

const initialState = {
  description: '',
}

const initialErrors = {
  description: false,
}

function ProcessForm(props) {
  const { keyword, handleClose, open } = props

  const isEditMode = keyword !== undefined && keyword !== null

  const token = useSelector((state) => state.auth.access_token)

  const [formState, setFormState] = useState(initialState)
  const [formErrors, setFormErrors] = useState(initialErrors)

  const validate = () => {
    const errors = cloneDeep(initialErrors)

    Object.keys(errors).forEach((key) => {
      if (formState[key] === '' || formState[key].length <= 2)
        errors[key] = true
    })

    if (Object.keys(errors).some((key) => errors[key])) {
      setFormErrors(errors)
      return false
    }

    return true
  }

  const handleSubmit = () => {
    if (!validate()) {
      toast.error(OPERATION_MESSAGES.CHECK_INFORMED_DATA)
      return
    }

    if (isEditMode) {
      updateProcessKeyword(token, formState)
        .then((response) => {
          if (response.status === 204) {
            toast.success(OPERATION_MESSAGES.RECORD_UPDATE_SUCCESS)
            handleClose()
          }
        })
        .catch(() => {
          toast.error(OPERATION_MESSAGES.RECORD_UPDATE_FAIL)
        })
    } else {
      createProcessKeyword(token, formState)
        .then((response) => {
          if (response.status === 201) {
            toast.success(OPERATION_MESSAGES.RECORD_ADD_SUCCESS)
            handleClose()
          }
        })
        .catch(() => {
          toast.error(OPERATION_MESSAGES.RECORD_ADD_FAIL)
        })
    }
  }

  const handleFieldChange = (event) => {
    const key = event.target.id
    const newFormState = cloneDeep(formState)
    newFormState[key] = event.target.value
    setFormState(newFormState)
  }

  const clearAndClose = () => {
    setFormState(initialState)
    setFormErrors(initialErrors)
    handleClose()
  }

  useEffect(() => {
    if (keyword) {
      setFormState(keyword)
    } else {
      setFormState(initialState)
    }
  }, [keyword])

  return (
    <DialogConfirm
      open={open}
      title="Palavra chave de processos"
      onConfirm={handleSubmit}
      onCancel={clearAndClose}
      contextText='Informe abaixo, a palavra-chave de processos. '
      showCloseButton={true}
      fullWidth={true}
    >
      <React.Fragment>
        <TextField
          autoFocus
          margin="dense"
          id="description"
          label="Palavra-chave"
          type="text"
          fullWidth
          variant="standard"
          required
          onChange={handleFieldChange}
          value={formState.description}
          error={formErrors.description}
        />

        <Alert severity="info" style={{ marginTop: '8px' }}>
          O sistema trata letras maiúsculas e minúsculas de forma indistinta.
        </Alert>
      </React.Fragment>
    </DialogConfirm>
  )
}

export default ProcessForm
